export default {
  props: {
    dollarQuote: {
      type: Number,
      default: 1,
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    subtotal() {
      return this.items.reduce((acc, i) => (acc += i.quantity * i.price), 0);
    },
    total() {
      return Number(this.subtotal * (1 + this.IVA / 100));
    },
    totalInArs() {
      return Number(this.total * this.dollarQuote);
    },
    ivaDiscount() {
      return Number(this.subtotal * (this.IVA / 100));
    },
  },
  mounted() {
    this.IVA = process.env.VUE_APP_IVA;
  },
  data() {
    return {
      IVA: 0,
    };
  },
};
